export default __webpack_public_path__ + "static/antigen-testing-7d772a91f4a06ea4a2a2fe1cb8724c2f.png";